import { render, staticRenderFns } from "./RepairPlace.vue?vue&type=template&id=64e83085"
import script from "./RepairPlace.vue?vue&type=script&lang=js"
export * from "./RepairPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports